import { render, staticRenderFns } from "./contract-record-main.vue?vue&type=template&id=c81608be&scoped=true&"
import script from "./contract-record-main.vue?vue&type=script&lang=js&"
export * from "./contract-record-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81608be",
  null
  
)

export default component.exports